import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { syncUserRoles } from "../../api/apiRoles";
import parseError from "../../utils/parseError";

export const useSyncUserRoles = () => {
    const queryClient = useQueryClient();
    const { mutate: syncUserRolesMutate, isPending: isSyncing } = useMutation({
        mutationFn: ({ userId, data }) => syncUserRoles(userId, data),
        onSuccess: (res) => {
            toast.success(res.message || "Roles updated");
            queryClient.invalidateQueries(["user-roles"]);
            queryClient.invalidateQueries(["customer"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to update roles"),
    });
    return { syncUserRolesMutate, isSyncing };
};
